import { plazaSearchParams } from "./server/filters";
import type { PlazaFilters, PlazaResult } from "./types";

export async function fetchPlazaSearch(
  filters: PlazaFilters,
  signal: AbortSignal,
  fetcher: typeof fetch = fetch,
): Promise<PlazaResult> {
  const query = plazaSearchParams(filters).split("?")[1] ?? "";
  const response = await fetcher(`/api/v1/plaza/avatars?${query}`, { signal });
  if (!response.ok) throw new Error("Plaza search unavailable");
  const data = await response.json();
  if (!data.success || !Array.isArray(data.list) || !data.catalog?.initialized
    || !Number.isSafeInteger(data.pagination?.page) || data.pagination.page < 1
    || !Number.isSafeInteger(data.pagination?.totalPages) || data.pagination.totalPages < 1
    || !Number.isSafeInteger(data.pagination?.total) || data.pagination.total < 0
    || !Number.isSafeInteger(data.pagination?.pageSize) || data.pagination.pageSize < 1) {
    throw new Error("Invalid plaza search response");
  }
  return {
    items: data.list,
    total: data.pagination.total,
    page: data.pagination.page,
    pageSize: data.pagination.pageSize,
    pageCount: data.pagination.totalPages,
    compatibilityMode: data.compatibilityMode === true,
    catalog: data.catalog,
  };
}
